import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PolicyChangeService = /** @class */ (function () {
    function PolicyChangeService(http) {
        this.http = http;
    }
    PolicyChangeService.prototype.issuePaymentMethod = function (payload) {
        return this.http.post(environment.server.api.portalpas + "/policy/issue-policy-change-for-payment-method", payload);
    };
    PolicyChangeService.prototype.setCarChange = function (policyCarChangeRequest) {
        var endpoint = environment.server.api.portalpas + "/policy/car-change/" + policyCarChangeRequest.policyPeriodId;
        return this.http.put(endpoint, policyCarChangeRequest);
    };
    PolicyChangeService.prototype.createPolicyChange = function (policyPeriodId, effectiveDate) {
        var payload = {
            policyPeriodId: policyPeriodId,
            effectiveDate: effectiveDate
        };
        var endpoint = environment.server.api.portalpasProxy + "/policycenter-policy/api/Policies/" + policyPeriodId + "/generate-change";
        return this.http.post(endpoint, payload)
            .pipe(map(function (response) {
            if (response.id) {
                return response.id;
            }
            else {
                return response;
            }
        }));
    };
    PolicyChangeService.prototype.policyChangeQuote = function (policyPeriodId, getSummary) {
        if (getSummary === void 0) { getSummary = true; }
        return this.http.get(environment.server.api.portalpas + "/Policy/" + policyPeriodId + "/quote?getSummary=" + getSummary);
    };
    PolicyChangeService.prototype.issueSubmission = function (jobNumber, branchNumber) {
        return this.http.post(environment.server.api.portalpas + "/Policy/issue-submission", {
            jobNumber: jobNumber,
            branchNumber: branchNumber,
            warningsThrowException: false
        });
    };
    PolicyChangeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PolicyChangeService_Factory() { return new PolicyChangeService(i0.ɵɵinject(i1.HttpClient)); }, token: PolicyChangeService, providedIn: "root" });
    return PolicyChangeService;
}());
export { PolicyChangeService };
